export default {"src":"/_next/static/media/smartwatch.35799267.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};